module.exports = __webpack_public_path__ + "img/hk.4e492fcd.png";